import { Chip, Flex } from '@brightdrop/bd-ui';
import type { MRT_Cell, MRT_Row } from '@brightdrop/table-ui';
import type { User } from '@gm-commercial/profile-model';
import { useSelector } from 'react-redux';

import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import { useGetOrganizationById } from '~/features/organizations/hooks/useGetOrganizationById';
import { selectActingProfileOrganization } from '~/store/profile/profileSlice.selectors';

interface UserFleetColumnCellProps {
  cell: MRT_Cell<User, string>;
  row: MRT_Row<User>;
}

const UserRoleColumnCell = ({ cell, row }: UserFleetColumnCellProps) => {
  const role = cell.getValue();
  const userId = row.original.id;
  const organizationsId =
    useSelector(selectActingProfileOrganization)?.id || '';

  const { orgDetails } = useGetOrganizationById(organizationsId);
  const primaryContactId = orgDetails?.primaryContact?.id;
  return (
    <Flex col gap={4} dataTestId="user-list-fleet-column">
      {userId === primaryContactId && (
        <Chip
          label={translateText('common:primaryContact')}
          chipColor="brand-blue"
          variant="outlined"
          size="small"
        />
      )}
      {translateText(`common:roleList.${role}`)}
    </Flex>
  );
};

export default UserRoleColumnCell;
